export default __webpack_public_path__ + "static/erik-b16ada18cd2ecd166420bee0769f85b3.png";